<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Identification Details</h4>
</div>
<div class="modal-body" *ngIf="false == loading">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="identificationForm" autocomplete="off">
        <fieldset>
			<div class="row">
				<div class="col-sm-3 mvd_form-group">
					<label class="required" title="* Required">Identification Type</label>
					<select class="mvd_form-control" (change)="identificationTypeChange(+$event.target.value)" formControlName="customerIdentificationTypeId" autofocus>
						<option *ngFor="let identification of customerIdentificationTypes" value="{{identification.id}}">{{identification.displayValue}}</option>
					</select>
				</div>
				<div class="col-sm-2 mvd_form-group">
					<label class="required" title="* Required">ID Number</label>
					<input type="text"
						   class="mvd_form-control"
						   *ngIf="!mask"
						   formControlName="customerIdentificationValue" />
					<p-inputMask *ngIf="mask"
								 [mask]="mask"
								 unmask="true"
								 formControlName="customerIdentificationValue"
								 styleClass="mvd_form-control">
					</p-inputMask>
					<div class="mvd_alert__validation" *ngIf="identificationForm.get('customerIdentificationValue').dirty || identificationForm.get('customerIdentificationValue').touched">
						<div class="mvd_alert__rule" *ngIf="identificationForm.get('customerIdentificationValue').hasError('required')">Value cannot be empty</div>
					</div>
				</div>
				<div class="col-sm-3 mvd_form-group" *ngIf="showOINButton">
					<button class="icon--edit btn--default" type="button" (click)="generateOIN()">Generate OIN</button>
				</div>
				<div class="col-sm-3 mvd_form-group" *ngIf="showCountry">
					<label>Country Code</label>
					<select class="mvd_form-control" formControlName="locationCode">
						<option *ngFor="let country of countryCodes" [value]="country.countryCode2">{{ country.countryDisplayValue }}</option>
					</select>
				</div>
				<div class="col-sm-2 mvd_form-group" *ngIf="showState">
					<label>State Code</label>
					<select class="mvd_form-control" formControlName="locationCode">
						<option *ngFor="let j of stateCodes" [value]="j.jurisdictionCode">{{ j.jurisdictionDisplayValue }}</option>
					</select>
				</div>
				<div class="col-sm-1 mvd_form-group" *ngIf="data.identificationId != 0">
					<label>&nbsp;</label>
					<a class="icon--delete" title="Delete Customer Identification" href="javascript:void(0)" (click)="deleteCustomerIdentification()"></a>
				</div>
				</div>
				<div class="row">
					<div class="col-sm-3 mvd_form-group">
						<label class="required" title="* Required">Effective Date</label>
						<p-calendar [maxDate]="endDate"
									[showIcon]="true"
									formControlName="effectiveDate"
									yearNavigator="true"
									[yearRange]="yearRange">
						</p-calendar>
						<div class="mvd_alert__validation" *ngIf="identificationForm.get('effectiveDate').dirty || identificationForm.get('effectiveDate').touched">
							<div class="mvd_alert__rule" *ngIf="identificationForm.hasError('startDateRequired')">Effective date is required</div>
							<div class="mvd_alert__rule" *ngIf="identificationForm.hasError('startAfterEndDate')">Effective date cannot be after End date</div>
						</div>
					</div>
					<div class="col-sm-3 mvd_form-group">
						<label>End Date</label>
						<p-calendar [showIcon]="true"
									[minDate]="effectiveDate"
									formControlName="endDate"
									yearNavigator="true"
									showButtonBar="true"
									[yearRange]="yearRange">
						</p-calendar>
						<div class="mvd_alert__validation" *ngIf="identificationForm.get('endDate').dirty || identificationForm.get('endDate').touched">
							<div class="mvd_alert__rule" *ngIf="identificationForm.hasError('endDateRequired')">End date is required</div>
						</div>
					</div>
				</div>
</fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" [disabled]="true == loading" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!(identificationForm.valid && identificationForm.dirty) || loading" [isLoading]="showButtonLoading" [btnText]="'Save'" (clicked)="saveIdentification()"></mvm-spinner-btn>
    </div>
</div>